import React, { useState } from "react";
import classes from "./styles.module.scss";
import { actionNotifier } from "../../components/ui/toast";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PopupFormModal from "./PopupFormModal";
import DeleteConfirm from "../councellingStudentContainer/features/DeleteConfirm";

const PopupNotificationContainer = ({ createPopup, getImageLink, isLoading, data }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingItem, setEditingItem] = useState(null);
    const [deleteId, setDeleteId] = useState(null);

    const rawNotifications = data?.notification || data?.data?.notification || data?.data?.rows || [];
    const existingNotifications = [...rawNotifications].sort((a, b) => (a.order || 0) - (b.order || 0));

    const handleOpenModal = () => {
        setEditingItem(null);
        setIsModalOpen(true);
    };

    const handleEdit = (item) => {
        setEditingItem(item);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingItem(null);
    };

    const handleSave = async (notificationData) => {
        try {
            let finalList = JSON.parse(JSON.stringify(existingNotifications));
            const newOrder = parseInt(notificationData.order);

            if (notificationData.id) {
                finalList = finalList.filter(item => item.id !== notificationData.id);
            }

            finalList.push({ ...notificationData, id: notificationData.id || Date.now().toString(), order: newOrder });

            const finalPayload = {
                notification: finalList.map(n => ({
                    id: n.id,
                    title: n.title,
                    description: n.description,
                    image: n.image,
                    alt: n.alt,
                    type: n.type,
                    order: n.order,
                    is_active: n.is_active,
                    start_date: new Date(n.start_date).toISOString(),
                    end_date: new Date(n.end_date).toISOString(),
                }))
            };

            await createPopup(finalPayload).unwrap();
            actionNotifier.success("Popup notifications updated successfully!");
        } catch (error) {
            console.error("Error saving popup:", error);
            actionNotifier.error("Failed to save popup notification");
            throw error;
        }
    };

    const handleDelete = (id) => {
        setDeleteId(id);
    };

    const confirmDelete = async () => {
        if (deleteId === null) return;

        try {
            const remainingNotifications = existingNotifications.filter(item => item.id !== deleteId);

            const finalPayload = {
                notification: remainingNotifications.map(n => ({
                    id: n.id,
                    title: n.title,
                    description: n.description,
                    image: n.image,
                    alt: n.alt,
                    type: n.type,
                    order: n.order,
                    is_active: n.is_active,
                    start_date: n.start_date,
                    end_date: n.end_date
                }))
            };

            await createPopup(finalPayload).unwrap();
            actionNotifier.success("Popup deleted successfully!");
            setDeleteId(null);

        } catch (error) {
            console.error("Error deleting popup:", error);
            actionNotifier.error("Failed to delete popup");
        }
    };

    return (
        <div className={classes.popup_page_container}>
            <div className={classes.page_header}>
                <div className={classes.form_title}>{" "}</div>
                <button
                    className={classes.add_new_btn_main}
                    onClick={handleOpenModal}
                >
                    <AddCircleOutlineIcon fontSize="small" /> Add Popup Notification
                </button>
            </div>

            {existingNotifications.length > 0 ? (
                <div className={classes.popup_list_container_full}>
                    <table className={classes.popup_table}>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Image</th>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Order</th>
                                <th>Status</th>
                                <th>Start Date</th>
                                <th>End Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {existingNotifications.map((item, idx) => (
                                <tr key={item.id || idx}>
                                    <td>{idx + 1}</td>
                                    <td>
                                        {item.image && (
                                            <img
                                                src={item.image}
                                                alt={item.alt || item.title}
                                                className={classes.table_image}
                                            />
                                        )}
                                    </td>
                                    <td>{item.title}</td>
                                    <td>{item.description?.substring(0, 50)}{item.description?.length > 50 ? '...' : ''}</td>
                                    <td>{item.order}</td>
                                    <td>
                                        <span className={item.is_active ? classes.status_active : classes.status_inactive}>
                                            {item.is_active ? "Active" : "Inactive"}
                                        </span>
                                    </td>
                                    <td>{item.start_date ? new Date(item.start_date).toLocaleDateString() : '-'}</td>
                                    <td>{item.end_date ? new Date(item.end_date).toLocaleDateString() : '-'}</td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <button
                                                className={classes.edit_btn}
                                                onClick={() => handleEdit(item)}
                                            >
                                                <EditOutlinedIcon fontSize="small" /> Edit
                                            </button>
                                            <button
                                                className={classes.delete_btn}
                                                onClick={() => handleDelete(item.id)}
                                            >
                                                <DeleteOutlineIcon fontSize="small" /> Delete
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className={classes.popup_list_container}>
                    <div className={classes.empty_state}>
                        No popup notifications found. Click "Add Popup Notification" to create one.
                    </div>
                </div>
            )}

            <PopupFormModal
                open={isModalOpen}
                handleClose={handleCloseModal}
                handleSave={handleSave}
                initialData={editingItem}
                getImageLink={getImageLink}
                isLoading={isLoading}
            />

            {deleteId !== null && (
                <DeleteConfirm
                    isModalOpen={true}
                    handleModal={confirmDelete}
                    setIsModalOpen={() => setDeleteId(null)}
                    title="Popup Notification"
                />
            )}
        </div>
    );
};

export default PopupNotificationContainer;
